import { TStoreAddress } from "../types";

function isAllRequiredFieldSet(address: TStoreAddress, noRequiredFields: (keyof TStoreAddress)[]) {
	return Object.entries(address)
		.filter(([key]) => !noRequiredFields.includes(key as keyof TStoreAddress))
		.every(([_, value]) => value !== undefined && value !== "");
}

export { isAllRequiredFieldSet };
